export default __webpack_public_path__ + "static/media/Hats04.44f779e5.png";